import {apiDELETE, apiGET, apiPOST} from "./RequestsCore";

/**
 * Returns a generated document (if existing) of the provided template, for that expedient and generated by that user.
 *
 * @param user_id
 * @param expedient_id
 * @param template_id
 * @returns {Promise<AxiosResponse<*>|T>}
 */
export async function getGeneratedDocumentWithUserExpedientAndTemplate(user_id, expedient_id, template_id) {
    return await apiGET('/api/expedient/' + expedient_id + '/template/' + template_id + '/user/' + user_id + '/generated-document');
}

export async function deleteGeneratedDocument(expedient_id, user_id, template_id, generated_document_id) {
    return await apiDELETE('/api/expedient/' + expedient_id + '/template/' + template_id + '/user/' + user_id + '/generated-document/' + generated_document_id);
}

export async function storeGeneratedDocument(html_content, template_content, expedient_id, template_id) {
    let data = {
        template_content: template_content,
        content: html_content,
    }

    return await apiPOST('/api/expedient/' + expedient_id + '/template/' + template_id + '/generated-document', data);
}
